import React from 'react';

interface SpinnerElementProps {
  modifiers?: string;
  className?: string;
}

const SpinnerElement = ({ modifiers, className }: SpinnerElementProps) => (
  <div data-am-spinner={modifiers ? `element ${modifiers}` : 'element'} className={className}>
    <svg
      className="spinner"
      viewBox="0 0 185.57 109.13"
      preserveAspectRatio="xMinYMid"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Loading</title>
      <circle className="spinner-dot-1" cx="4.25" cy="39.68" r="4.25" />
      <circle className="spinner-dot-2" cx="25.15" cy="68.03" r="4.96" />
      <circle className="spinner-dot-3" cx="46.04" cy="96.38" r="6.38" />
      <circle className="spinner-dot-4" cx="66.93" cy="68.03" r="7.09" />
      <circle className="spinner-dot-5" cx="87.82" cy="39.68" r="8.5" />
      <circle className="spinner-dot-6" cx="108.72" cy="68.03" r="10.63" />
      <circle className="spinner-dot-7" cx="129.61" cy="96.38" r="12.76" />
      <circle className="spinner-dot-8" cx="150.5" cy="68.03" r="13.47" />
      <circle className="spinner-dot-9" cx="171.4" cy="39.68" r="14.17" />
      <circle className="spinner-dot-10" cx="129.61" cy="39.68" r="12.05" />
      <circle className="spinner-dot-11" cx="66.93" cy="11.34" r="7.09" />
      <circle className="spinner-dot-12" cx="150.5" cy="11.34" r="11.34" />
      <circle className="spinner-dot-13" cx="108.72" cy="11.34" r="10.63" />
      <circle className="spinner-dot-14" cx="46.04" cy="39.68" r="6.38" />
      <circle className="spinner-dot-15" cx="25.15" cy="11.34" r="4.96" />
    </svg>
  </div>
);

export default SpinnerElement;
